import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import ProviderRoute from './components/ProviderRoute';
import ProviderOrdersPage from './pages/provider/ProviderOrdersPage';
import ProviderEarningsPage from './pages/provider/ProviderEarningsPage';
import ProviderNotificationsPage from './pages/provider/ProviderNotificationsPage';
import ProviderProfilePage from './pages/provider/ProviderProfilePage';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import ServiceCategoriesPage from './pages/ServiceCategoriesPage';
import CategoryFieldsPage from './pages/CategoryFieldsPage';
import ProvidersPage from './pages/ProvidersPage';
import ProviderDetailPage from './pages/ProviderDetailPage';
import UsersPage from './pages/UsersPage';
import ModerationPage from './pages/ModerationPage';
import OrdersPage from './pages/OrdersPage';
import OrderDetailPage from './pages/OrderDetailPage';
import DisputesPage from './pages/DisputesPage';
import UserReportsPage from './pages/UserReportsPage';
import NotificationsPage from './pages/NotificationsPage';
import CommissionPage from './pages/CommissionPage';
import CreditsPage from './pages/CreditsPage';
import ReportsPage from './pages/ReportsPage';
import TestCleanupPage from './pages/TestCleanupPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/service-categories"
            element={
              <PrivateRoute>
                <ServiceCategoriesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/service-categories/:categoryId/fields"
            element={
              <PrivateRoute>
                <CategoryFieldsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/providers"
            element={
              <PrivateRoute>
                <ProvidersPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/providers/:id"
            element={
              <PrivateRoute>
                <ProviderDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <PrivateRoute>
                <UsersPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/moderation"
            element={
              <PrivateRoute>
                <ModerationPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/orders"
            element={
              <PrivateRoute>
                <OrdersPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/orders/:id"
            element={
              <PrivateRoute>
                <OrderDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/disputes"
            element={
              <PrivateRoute>
                <DisputesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/user-reports"
            element={
              <PrivateRoute>
                <UserReportsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/notifications"
            element={
              <PrivateRoute>
                <NotificationsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/credits"
            element={
              <PrivateRoute>
                <CreditsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/commission"
            element={
              <PrivateRoute>
                <CommissionPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/reports"
            element={
              <PrivateRoute>
                <ReportsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/test-cleanup"
            element={
              <PrivateRoute>
                <TestCleanupPage />
              </PrivateRoute>
            }
          />
          {/* Provider (hizmat ko'rsatuvchi) area — bottom-tab order per #660 */}
          <Route
            path="/provider"
            element={<Navigate to="/provider/orders" replace />}
          />
          <Route
            path="/provider/orders"
            element={
              <ProviderRoute>
                <ProviderOrdersPage />
              </ProviderRoute>
            }
          />
          <Route
            path="/provider/earnings"
            element={
              <ProviderRoute>
                <ProviderEarningsPage />
              </ProviderRoute>
            }
          />
          <Route
            path="/provider/notifications"
            element={
              <ProviderRoute>
                <ProviderNotificationsPage />
              </ProviderRoute>
            }
          />
          <Route
            path="/provider/profile"
            element={
              <ProviderRoute>
                <ProviderProfilePage />
              </ProviderRoute>
            }
          />
          {/* Noma'lum /admin/* yo'l (masalan /admin/provider-applications) — admin bosh sahifasiga;
              PrivateRoute o'zi kirmagan foydalanuvchini login'ga yuboradi. */}
          <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
